import { ListView } from '../../list_view/listView';
import { Wrapper } from './weeklyPerformanceSection';
import { localDateToUSFormat } from '../driver_page_components/payoutAdjustmentsSection';
import { priceOnFinish } from '../../../../supplementary_components/priceInputDelegate';
import { formatPaidBy } from '../../../../pages/reports/payableInvoiceFormFields';
import { LoadingIcon } from '../../../../supplementary_components/loading_icon';
import { useTruckInvoicePreview } from './truckInvoicePreview';
import { openTruckMaintenanceInvoicesPopup } from './truckMaintenanceInvoicesPopup';

const SHOP_ELLIPSIS = 'min-width:0; overflow:hidden; & > span { display:block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }';

const listConf = {
    columnProportions: '0.8fr 0.8fr 1.7fr 0.7fr',
    columns: [
        {
            label: 'Date',
            columnName: 'createdDate',
            valueGenerator: (row) => {
                const formatted = localDateToUSFormat(row.createdDate);
                return formatted || '-';
            },
        },
        {
            label: 'Paid By',
            columnName: 'paidBy',
            valueGenerator: (row) => formatPaidBy(row.paidBy),
        },
        {
            label: 'Shop',
            columnName: 'shopName',
            conditionalFormatting: () => SHOP_ELLIPSIS,
            valueGenerator: (row) => {
                const name = row.shopName != null ? String(row.shopName).trim() : '';
                return name || '-';
            },
        },
        {
            label: 'Rate',
            columnName: 'amount',
            alignment: 'right',
            valueGenerator: (row) => (row.amount == null || row.amount === '' ? '-' : priceOnFinish(row.amount)),
        },
    ],
};

const Message = ({ text }) => (
    <Wrapper>
        <div className="NoData"><span>{text}</span></div>
    </Wrapper>
);

export const MaintenanceInvoicesViewAll = ({ truckId, truckNumber }) => {
    const { status, rows } = useTruckInvoicePreview(truckId);
    const enabled = status === 'ready' && rows.length > 0;
    return (
        <button
            type="button"
            disabled={!enabled}
            style={enabled ? undefined : { opacity: 0.4, cursor: 'default', textDecoration: 'none' }}
            onClick={() => openTruckMaintenanceInvoicesPopup({ truckId, truckNumber })}
        >
            View All
        </button>
    );
};

export const MaintenanceInvoicesSection = ({ truckId }) => {
    const { status, rows } = useTruckInvoicePreview(truckId);

    if (status === 'loading') {
        return <LoadingIcon state height="6rem" wrapperHeight="6rem" iconHeight="2.4rem" />;
    }
    if (status === 'error') return <Message text="COULDN'T LOAD INVOICES" />;
    if (rows.length === 0) return <Message text="NO MAINTENANCE INVOICES" />;
    return <ListView ListConf={listConf} Data={rows} Error={null} NoFooter />;
};
